(function () {
  const shieldWidgetTemplate = `
      <div id="shield-container">
        <div id="shield-container-left">
          <img
            loading="eager"
            class="shield-logo"
            id="logo"
            src="https://shieldshippingprotection.com/shield-widget-logo.png"
            width="24"
            height="24"
            alt="Shield Shipping Protection"
          >
          <div>
            <div id="shield-container-title">
              <span class="text-loader" id="text-loader"></span>
  
              <div class="shield-primary" id="shield-title">
                <span class="skeleton-box" style="width: 100%"></span>
              </div>
            </div>
  
            <div id="shield-subtitle"></div>
          </div>
        </div>
  
        <div id="shield-container-right">
          <div class="switch-container">
            <span class="loader" id="loader"></span>
            <label class="switch" id="toggle-switch">
              <input type="checkbox" id="cartToggle">
              <span class="slider round"></span>
            </label>
          </div>
          <div id="shield-price"></div>
        </div>
      </div>
    `;

  // Function to initialize the Shield widget
  function initializeShieldWidget(metafields) {
    const shippingProtectionElement = document.createElement("div");
    shippingProtectionElement.innerHTML = shieldWidgetTemplate;
    shippingProtectionElement.classList.add("shield-widget");

    const insertWidget = (checkoutElement) => {
      if (checkoutElement && checkoutElement.parentNode) {
        checkoutElement.parentNode.insertBefore(
          shippingProtectionElement,
          checkoutElement
        );
      }
    };

    const initializeCartToggle = () => {
      const cartToggle = document.getElementById("cartToggle");
      if (cartToggle) {
        cartToggle.onchange = async () => {
          await handleCartToggle();
        };
      } else {
        console.error("cartToggle element not found.");
      }
    };

    const checkoutElement = document.getElementsByClassName(
      "rebuy-cart__checkout-button"
    )[0];

    console.log("checkout element", checkoutElement);
    if (checkoutElement) {
      insertWidget(checkoutElement);
      initializeCartToggle();
      setInitialToggleValue(metafields);
    }
  }

  // Constants
  const PRODUCTION = true;
  const SHIELD_API_URL = PRODUCTION
    ? "https://ship.gadget.app/api/graphql"
    : "https://ship--development.gadget.app/api/graphql";

  async function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // Adds a product to the current cart based on variant
  async function addToCartMultiple(items) {
    const itemsToAdd = items.map((item) => ({
      quantity: item.quantity,
      id: item.variantId,
      selling_plan: item.selling_plan,
    }));

    if (!itemsToAdd.length) return;

    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        items: itemsToAdd,
      }),
    })
      .then((response) => response.json())
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async function removeVariantsFromCartByKey(variantKeys, quantity) {
    const updates = variantKeys.reduce((acc, variantKey) => {
      acc[variantKey] = quantity;
      return acc;
    }, {});

    if (!Object.getOwnPropertyNames(updates).length) return;

    await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        updates,
      }),
    })
      .then((response) => response.json())
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  // Gets protection status from backend
  async function getProtectionCartSettings(shopIdentifier) {
    try {
      const result = await fetch(SHIELD_API_URL, {
        headers: {
          accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          query: `
              mutation GetProtectionCartSettingsWithParam(
                $shopIdentifier: String!
              ) {
                getProtectionCartSettingsWithParam(
                  shopIdentifier: $shopIdentifier
                ) {
                  success
                  errors {
                    message
                  }
                  result
                }
              }
        `,
          variables: {
            shopIdentifier,
          },
        }),
        method: "POST",
      });
      const json = await result.json();
      return json.data.getProtectionCartSettingsWithParam.result;
    } catch (e) {
      console.log("Error fetching protection value", e);
      return false;
    }
  }

  async function getProtectionProductVariantForCart(shopIdentifier, cartItems) {
    try {
      const result = await fetch(SHIELD_API_URL, {
        headers: {
          accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          query: `
              mutation getProtectionProductVariantWithCartParams(
                  $shopIdentifier: String!
                  $cartItems: [GetProtectionProductVariantWithCartParamsCartItemsElementTypeInput!]
                ) {
                  getProtectionProductVariantWithCartParams(
                    shopIdentifier: $shopIdentifier
                    cartItems: $cartItems
                  ) {
                    success
                    errors {
                      message
                    }
                    result
                  }
                }
              `,
          variables: {
            shopIdentifier,
            cartItems,
          },
        }),
        method: "POST",
      });

      const json = await result.json();

      return json.data.getProtectionProductVariantWithCartParams.result;
    } catch (e) {
      console.log("Error getting protection product variant", e);
    }
  }

  function setWidgetSettings(widgetCustomizations) {
    const localWidgetCustomizations = window.localStorage.getItem(
      "com.shield:customization"
    );

    const localWidgetCustomizationsObject = JSON.parse(
      localWidgetCustomizations
    );

    // Title
    const titleText =
      localWidgetCustomizationsObject?.title ??
      widgetCustomizations?.title ??
      "Fling Package Protection";
    const titleEl = document.getElementById("shield-title");
    titleEl.innerHTML = titleText;
    const SHIELD_WIDGET_LOGO_URL =
      "https://www.shieldshippingprotection.com/shield-widget-logo.png";

    const subtitleHtml =
      localWidgetCustomizationsObject?.subtitleHtml ??
      widgetCustomizations?.subtitleHtml ??
      "<p>If lost, stolen, or damaged, we replace";
    const subtitleEl = document.getElementById("shield-subtitle");
    subtitleEl.innerHTML = subtitleHtml;

    const thumbnailType =
      localWidgetCustomizationsObject?.thumbnailType ??
      widgetCustomizations.thumbnailType;
    const customThumbnail =
      localWidgetCustomizationsObject?.customThumbnail?.url ??
      widgetCustomizations?.customThumbnail?.url ??
      SHIELD_WIDGET_LOGO_URL;

    const shieldLogoElement = document.getElementsByClassName("shield-logo")[0];
    shieldLogoElement.src = customThumbnail;
    shieldLogoElement.style.display = "block";
  }

  function setWidgetPrice(price) {
    const storedPriceStr = window.localStorage.getItem(
      "com.shield:cart_enabled"
    );
    let resolvedPrice = price ?? storedPriceStr ?? "";
    const priceLabel = "$" + resolvedPrice.toFixed(2);
    const priceElement = document.getElementById("shield-price");
    priceElement.innerHTML = priceLabel;
  }

  async function fetchShopifyCart() {
    const res = await fetch("/cart.js");
    const json = await res.json();
    return json;
  }

  function toggleWidgetOn() {
    document.getElementById("cartToggle").checked = true;
    window.localStorage.setItem("com.shield:cart_enabled", "true");
  }

  function toggleWidgetOff() {
    document.getElementById("cartToggle").checked = false;
    window.localStorage.setItem("com.shield:cart_enabled", "false");
  }

  function isWidgetLocallyOn() {
    return window.localStorage.getItem("com.shield:cart_enabled")
      ? window.localStorage.getItem("com.shield:cart_enabled") === "true"
      : null;
  }

  function isWidgetLocallyOff() {
    return window.localStorage.getItem("com.shield:cart_enabled") == "false";
  }

  function setWidgetLoading(isLoading, showTextLoader) {
    if (isLoading) {
      if (showTextLoader) {
        document.getElementById("text-loader").style.display = "block";
      }
      document.getElementById("loader").style.display = "block";
      document.getElementById("toggle-switch").style.display = "none";
    } else {
      if (showTextLoader) {
        document.getElementById("text-loader").style.display = "none";
      }
      document.getElementById("loader").style.display = "none";
      document.getElementById("toggle-switch").style.display = "block";
    }
  }

  function formatShopifyCartItems(cart) {
    const cartItems = cart.items;

    return cartItems.map((item) => ({
      id: String(item.id),
      key: item.key,
      quantity: item.quantity,
      variant_id: String(item.variant_id),
      product_id: String(item.product_id),
      line_price: item.line_price,
      selling_plan_id:
        item.selling_plan_allocation?.selling_plan?.id?.toString() ?? undefined,
    }));
  }

  async function setInitialToggleValue(metafields) {
    setWidgetLoading(true, true);

    const locallyEnabled = isWidgetLocallyOn();
    const defaultEnabled = metafields.defaultEnabled;
    let protectionEnabled = false;

    const shopifyCart = await fetchShopifyCart();
    if (!shopifyCart) return;

    let widgetCustomizations = await getProtectionCartSettings(
      String(window.location.href)
    );

    window.localStorage.setItem(
      "com.shield:customization",
      JSON.stringify(widgetCustomizations)
    );

    const formattedItems = formatShopifyCartItems(shopifyCart);

    const protectionProductVariants = await getProtectionProductVariantForCart(
      String(window.location.href),
      formattedItems
    );

    await removeExistingProductVariantsInCart(protectionProductVariants);

    const hasProtectionProductInCart = shopifyCart.items.some((i) => {
      return protectionProductVariants.some(
        (variant) => String(i.product_id) == String(variant.productId)
      );
    });

    const totalProtectionPrice = protectionProductVariants.reduce(
      (acc, currentVariant) => acc + Number(currentVariant.price),
      0
    );

    if (protectionProductVariants.length > 0) {
      setWidgetSettings(widgetCustomizations);
      setWidgetPrice(totalProtectionPrice);
    }

    setWidgetLoading(false, true);

    if (locallyEnabled == false) {
      return;
    }

    if (defaultEnabled || hasProtectionProductInCart) {
      toggleWidgetOn();
      protectionEnabled = true;
    }

    await updateShopifyProtectionProduct(
      protectionEnabled,
      protectionProductVariants
    );
  }

  async function readdShieldVariants() {
    const locallyEnabled = isWidgetLocallyOn();
    if (locallyEnabled == false) {
      return;
    }

    setWidgetLoading(true, false);

    const shopifyCart = await fetchShopifyCart();
    if (!shopifyCart) return;

    const formattedItems = formatShopifyCartItems(shopifyCart);

    const protectionProductVariants = await getProtectionProductVariantForCart(
      String(window.location.href),
      formattedItems
    );

    const totalProtectionPrice = protectionProductVariants.reduce(
      (acc, currentVariant) => acc + Number(currentVariant.price),
      0
    );

    if (protectionProductVariants.length > 0) {
      setWidgetPrice(totalProtectionPrice);
    }

    await removeExistingProductVariantsInCart(protectionProductVariants);

    await updateShopifyProtectionProduct(true, protectionProductVariants);

    setWidgetLoading(false, false);

    setWidgetSettings();
  }

  async function updateShopifyProtectionProduct(
    protectionEnabled,
    protectionProductVariants
  ) {
    const totalProtectionPrice = protectionProductVariants.reduce(
      (acc, currentVariant) => acc + Number(currentVariant.price),
      0
    );

    setWidgetPrice(totalProtectionPrice);

    if (protectionEnabled) {
      await addToCartMultiple(
        protectionProductVariants.map((variant) => ({
          quantity: 1,
          variantId: variant.id,
          selling_plan: variant.selling_plan,
        }))
      );
    } else {
      await removeExistingProductVariantsInCart(protectionProductVariants);
    }

    removeShieldItemFromCart();
  }

  async function removeExistingProductVariantsInCart(
    protectionProductVariants
  ) {
    const shopifyCart = await fetchShopifyCart();

    const shieldProductVariantsInCart = shopifyCart.items.filter((item) =>
      protectionProductVariants.some(
        (variant) => String(item.product_id) === String(variant.productId)
      )
    );

    const variantKeys = shieldProductVariantsInCart.map(
      (variant) => variant.key
    );

    await removeVariantsFromCartByKey(variantKeys, 0);
  }

  async function handleCartToggle() {
    const oldProtectionEnabled =
      window.localStorage.getItem("com.shield:cart_enabled") == "true";

    const newProtectionEnabled = oldProtectionEnabled ? false : true;

    if (newProtectionEnabled == true) {
      toggleWidgetOn();
    } else {
      toggleWidgetOff();
    }

    const shopifyCart = await fetchShopifyCart();

    const formattedItems = formatShopifyCartItems(shopifyCart);

    const protectionProductVariants = await getProtectionProductVariantForCart(
      String(window.location.href),
      formattedItems
    );

    await removeExistingProductVariantsInCart(protectionProductVariants);

    await updateShopifyProtectionProduct(
      newProtectionEnabled,
      protectionProductVariants
    );

    document.dispatchEvent(new CustomEvent("cart:updated"));
  }

  // Add the CSS styles
  const styles = `
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
  
      /* ===== Layout ===== */
  
      .shield-widget {
        display: flex;
        width: 100%;
        margin-top: 20px;
      }
  
      #shield-container {
        display: flex;
        border-radius: 8px;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        margin-bottom: 16px;
      }
  
      #shield-container-left {
        display: flex;
        flex-direction: row;
        gap: 8px;
      }
  
      #shield-container-title {
        display: flex;
        gap: 4px;
      }
  
      #shield-container-right {
        display: flex;
        flex-direction: column;
        vertical-align: middle;
        align-items: center;
        gap: 8px;
      }
  
      #shield-container * {
        font-family: 'Inter', sans-serif !important;
      }
  
      .shield-logo {
        display: none;
        align-self: center;
      }
  
      .shield-text {
        margin: 0px;
        font-size: 15px;
        letter-spacing: -0.01em;
        word-spacing: -0.01em;
        flex: 1;
      }
  
      #shield-subtitle {
        font-size: 12px;
        font-weight: 400;
        color: #00000080;
      }
  
      #shield-price {
         font-size: 12px;
        font-weight: 600;
      }
  
      .shield-primary {
        opacity: 1;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
      }
  
      .shield-secondary {
        opacity: 0.8;
      }
  
      #shipping-protection-amount {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        margin: 0;
        padding-bottom: 4px;
      }
  
      /* ===== Switch ===== */
  
      .switch-container {
        margin-right: auto;
      }
  
      .switch {
        position: relative;
        display: inline-block;
        width: 32px;
        height: 16px;
      }
  
      .switch input {
        opacity: 0;
        width: 0;
        height: 0;
      }
  
      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
  
      .slider:before {
        position: absolute;
        content: '';
        height: 12px;
        width: 12px;
        left: 4.5px;
        bottom: 2px;
        background-color: white;
        -webkit-transition: 0.25s;
        transition: 0.25s;
      }
  
      input:checked + .slider {
        background-color: black;
      }
  
      input:checked + .slider:before {
        -webkit-transform: translateX(14px);
        -ms-transform: translateX(14px);
        transform: translateX(14px);
      }
  
      input:focus + .slider {
        box-shadow: 0 0 1px #003f79;
      }
  
      /* Rounded sliders */
      .slider.round {
        border-radius: 32px;
      }
  
      .slider.round:before {
        border-radius: 50%;
      }
  
      .shield-help-icon {
        vertical-align: middle;
      }
  
      .text-loader {
        display: inline-block;
        height: 1em;
        position: relative;
        overflow: hidden;
        background-color: #DDDBDD;
        width: 14rem;
      }
  
      .text-loader::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0) 100%
        );
        animation: shimmer 5s infinite;
        content: '';
      }
  
  
      @keyframes shimmer {
        100% {
          transform: translateX(100%);
        }
      }
  
      .loader {
        width: 24px;
        height: 24px;
        border: 3px solid #c7c7c7 !important;
        border-bottom-color: transparent !important;
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
      }
  
      @keyframes rotation {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `;

  // Function to add styles to the document
  function addStylesToDocument() {
    const styleElement = document.createElement("style");
    styleElement.textContent = styles;
    document.head.appendChild(styleElement);
  }

  function getMetafields() {
    return (metafields = {
      pluginEnabled: window.shieldMetafields.pluginEnabled,
      defaultEnabled: window.shieldMetafields.defaultEnabled,
    });
  }

  function removeShieldItemFromCart() {
    const shieldCartItem = document.querySelector(
      '.mu-cart-item[data-product-id="8989489692901"]'
    );
    if (shieldCartItem) {
      shieldCartItem.remove();
    }
  }

  function initializeCartUpdateListener() {
    console.log("initialize cart update");

    window.originXHRSend = XMLHttpRequest.prototype.send;

    // Override XHR send
    XMLHttpRequest.prototype.send = function (...n) {
      // Add load event listener to intercept responses
      this.addEventListener("load", async () => {
        // Handle cart update/change requests
        console.log(this.responseURL);
        if (/\/cart\/change(?:\.js)?/.test(this.responseURL)) {
          delay(450).then(() => {
            readdShieldVariants();
          });
        }
      });

      // Call original XHR send
      window.originXHRSend.apply(this, n);
    };

    const originalFetch = window.fetch;

    window.fetch = function (...args) {
      return originalFetch.apply(this, args).then((response) => {
        // Clone the response to avoid consuming the body
        const clonedResponse = response.clone();

        if (/\/cart\/change(?:\.js)?/.test(clonedResponse.url)) {
          // Reinitialize widget
          console.log("change detected");
          delay(450).then(() => {
            readdShieldVariants();
          });
        }

        // Return the original response so other code can handle it as needed
        return response;
      });
    };
  }

  // Create a function to initialize your widget
  const initializeWidget = () => {
    let metafields = getMetafields();
    addStylesToDocument();

    delay(200).then(() => {
      initializeShieldWidget(metafields);
    });

    initializeCartUpdateListener();
  };

  function setupMiniCartObserver() {
    const cartElement = document.getElementsByClassName("rebuy-cart")[0];
    if (!cartElement) {
      console.warn(
        'Element with id "cartElement" not found. Shield widget initialization delayed.'
      );
      return;
    }

    let hasHandledMutation = false;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes") {
          if (
            cartElement.classList.contains("is-visible") &&
            !hasHandledMutation
          ) {
            hasHandledMutation = true; // Set flag to prevent future executions
            const existingShieldWidget =
              document.querySelector(".shield-widget");

            if (!existingShieldWidget) {
              initializeWidget();
            } else {
              readdShieldVariants();
            }
          }
        }
      });
    });

    observer.observe(cartElement, { attributes: true });
  }

  document.addEventListener("DOMContentLoaded", () => {
    const pollForCartElement = setInterval(() => {
      const cartElement = document.getElementsByClassName("rebuy-cart")[0];
      console.log("cart element", cartElement);
      if (cartElement) {
        setupMiniCartObserver();
        clearInterval(pollForCartElement); // Stop polling once element is found
      }
    }, 200);
  });
})();
